<template>
  <div>
    <h1>3D Cartesian Coordinate System</h1>
    <bolt-scene
      :rotation="rotation"
      :start-rotation="startRotation"
      :end-rotation="endRotation"
      :rotation-axis="rotationAxis"
      :auto-rotate="autoRotate"
      :rotation-speed="rotationSpeed"
      :is-animating="isAnimating"
      :thresholds="thresholds"
      @animation-complete="isAnimating = false"
      @update:rotation="rotation = $event"
      class="three-container"
    />
    <v-row class="mt-4">
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Bolt Rotation</v-card-title>
          <v-card-text>
            <p>Start rotation: {{ startRotation.toFixed(2) }}°</p>
            <p>End rotation: {{ endRotation.toFixed(2) }}°</p>
            <p>
              Current rotation: {{ rotation.toFixed(2) }}° around
              {{ rotationAxis.toUpperCase() }}-axis
            </p>
            <p>
              Total deviation: {{ (endRotation - startRotation).toFixed(2) }}°
            </p>
            <v-btn
              dark
              color="primary"
              @click="startAnimation"
              :disabled="isAnimating"
              class="mb-4"
            >
              Animate Deviation
            </v-btn>
            <v-slider
              class="mt-5"
              v-model="rotation"
              min="0"
              max="360"
              thumb-label="always"
              color="black"
            ></v-slider>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card>
          <v-card-title>Rotation Controls</v-card-title>
          <v-card-text>
            <h3 class="text-subtitle-1 mb-2">Color Thresholds</h3>
            <v-row>
              <v-col cols="4">
                <label class="text-color-light mb-2">Secure Threshold</label>
                <v-text-field
                  v-model.number="thresholds.green"
                  type="number"
                  outlined
                  hide-details
                  class="font-size-input border border-radius-md placeholder-lighter text-color-light"
                ></v-text-field>
                <div class="text-caption text-color-light mt-1">Degrees for green color</div>
              </v-col>
              <v-col cols="4">
                <label class="text-color-light mb-2">Warning Threshold</label>
                <v-text-field
                  v-model.number="thresholds.yellow"
                  type="number"
                  outlined
                  hide-details
                  class="font-size-input border border-radius-md placeholder-lighter text-color-light"
                ></v-text-field>
                <div class="text-caption text-color-light mt-1">Degrees for yellow color</div>
              </v-col>
              <v-col cols="4">
                <label class="text-color-light mb-2">Critical Threshold</label>
                <v-text-field
                  v-model.number="thresholds.red"
                  type="number"
                  outlined
                  hide-details
                  class="font-size-input border border-radius-md placeholder-lighter text-color-light"
                ></v-text-field>
                <div class="text-caption text-color-light mt-1">Degrees for red color</div>
              </v-col>
            </v-row>
            <v-divider class="my-4"></v-divider>
            <label class="text-color-light mb-2">Rotation Axis</label>
            <v-select
              v-model="rotationAxis"
              :items="axes"
              outlined
              hide-details
              class="font-size-input border border-radius-md placeholder-lighter text-color-light"
            ></v-select>
            <v-checkbox v-model="autoRotate" label="Auto Rotate"></v-checkbox>
            <v-slider
              v-if="autoRotate"
              v-model="rotationSpeed"
              min="0.1"
              max="5"
              step="0.1"
              label="Speed"
              thumb-label="always"
            ></v-slider>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BoltScene from '@/components/BoltScene.vue';

export default {
  name: "TestView",
  components: {
    BoltScene
  },
  data() {
    return {
      rotation: 0,
      startRotation: 0,
      endRotation: 45, // Example end rotation
      rotationAxis: "y",
      axes: [
        { text: "X Axis", value: "x" },
        { text: "Y Axis", value: "y" },
        { text: "Z Axis", value: "z" },
      ],
      autoRotate: false,
      rotationSpeed: 1,
      isAnimating: false,
      thresholds: {
        green: 5,
        yellow: 25,
        red: 60,
      }
    };
  },
  methods: {
    startAnimation() {
      this.isAnimating = true;
    }
  }
};
</script>

<style scoped>
.three-container {
  width: 100%;
  height: 500px;
  background-color: #f0f0f0;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: block;
}
</style>
